import styled, {css} from "styled-components";
import {ButtonProps} from "@FRAMEWORK/ui/types/d";
import React from "react";

interface Props extends ButtonProps {
	text?: string | boolean;
	size?: "default" | "submit";
	types?: "base" | "basic" | "confirm" | "gray";
	width?: "basic" | "full";
	onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const StyledButton = styled.button<Props>`
	// padding: 0 40px;
	border: 1px solid var(--bl-color);
	background-color: #fff;
	color: var(--emp-color);
	font-size: var(--medium-size);
	font-family: "PT-regular";
	font-weight: normal;
	white-space: nowrap;
	overflow: hidden;

	&[type="button"]:disabled {
		border-color: #eee;
		background-color: #eee;
		color: #a9a9a9;
		cursor: unset;
	}

	${props => {
		if (props.types === "basic") {
			return css`
				border-color: transparent;
				background-color: var(--default-color);
				color: #fff;
				&[type="button"]:disabled {
					background: #eee;
					color: var(--gray-color);
					cursor: unset;
				}
			`;
		}
		if (props.types === "confirm") {
			return css`
				border-color: transparent;
				background-color: var(--yellow-color);
				color: var(--emp-color);
				&[type="button"]:disabled {
					background: #eee;
					color: var(--gray-color);
					cursor: unset;
				}
			`;
		}
		if (props.types === "gray") {
			return css`
				border-color: #eee;
				background-color: #eee;
				color: #a9a9a9;
				&[type="button"]:disabled {
					background: #eee;
					color: var(--gray-color);
					cursor: unset;
				}
			`;
		}
	}}
	${props =>
		props.size === "default"
			? css`
					height: 38px;
					font-size: var(--basic-size);
			  `
			: css`
					min-width: 140px;
					height: 50px;
			  `};

	${props =>
		props.width === "full"
			? css`
					width: 100%;
			  `
			: css`
					min-width: 110px;
					padding: 0 20px;
			  `}

	+ button {
		margin-left: 10px;
	}

	> span {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		border: none;
		overflow: hidden;
		clip: rect(0 0 0 0);
	}
`;

const TextButton = ({text, ...props}: Props) => (
	<StyledButton type="button" {...props}>
		{text}
	</StyledButton>
);

export default TextButton;
